export const CONTACT_ENDPOINT = "/contact";
export const BOOK_MEETING_ENDPOINT = "/book/call";
export const APPLY_JOB_ENDPOINT = "/solliciteren";
export const BLOG_URL = "/blog";
